import React from 'react';
import classes from './Card2.module.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/free-regular-svg-icons';
import { faHeart as filledHeart} from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { addWishlistItem, deleteWishlistItem } from '../../Store/actions/WishlistAction';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { urls } from '../../Routes/Urls';
import { getClasses } from '../../Util';

const Card = ({ className,image, title, author, price,bookData,altText,onClick,isBestSeller=true,isWishListItem = false,wishlistItemId }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const currentUser = useSelector((state) => state.user.currentUser )

  const handleAddWishlist = (e) => {
    e.stopPropagation()
    if(currentUser?.id){
      addWishlistItem(bookData,1,dispatch,true)
    }else{
      history.push(urls.LOGIN);
    }
  }

  const handleRedirect = () => {
    if(isBestSeller) {
      window.gtag("event", "select_item", {
        item_list_name: "Best Seller Books",
        items: [
          {
            item_id: bookData?.sku,
            item_name: bookData?.title,
            affiliation: "Rare biblio",
            index: 0,
            item_brand: "Rare Biblio",
            item_category: "Best Seller Books",
            item_category2: bookData?.genres || "Fiction",
            item_category3: bookData?.language || "English",
            item_list_id: "related_products",
            item_list_name: "Best Seller Book Listing",
            item_variant: "Genuine Leather",
            price: price?.discounted ? price?.discounted : price?.original,
            quantity: 1
          }
        ]
      });
      history.push({
        pathname: `${urls.BESTSELLERPDP}/${bookData.id}/${bookData?.title_slug}`,
        state: { bookData }
    });
    } else {
      window.gtag("event", "select_item", {
        item_list_name: "Books",
        items: [
          {
            item_id: bookData?.sku,
            item_name: bookData?.title,
            affiliation: "Rare biblio",
            index: 0,
            item_brand: "Rare Biblio",
            item_category: "Books",
            item_category2: bookData?.genres || "Fiction",
            item_category3: bookData?.language || "English",
            item_list_id: "related_products",
            item_list_name: "Book Listing",
            item_variant: "Genuine Leather",
            price: price?.discounted ? price?.discounted : price?.original,
            quantity: 1
          }
        ]
      });
      history.push({
        pathname: `${urls.PRODUCTDETAIL}/${bookData.id}/${bookData?.title_slug}`,
        state: { bookData }
    });
    }
}
const handleRemove = (e) => {
  e.stopPropagation()
  deleteWishlistItem(wishlistItemId, dispatch);
};

let selectedCurrency = "USD";
  if (currentUser) {
    selectedCurrency = currentUser?.preferredCurrency ? currentUser?.preferredCurrency : "USD";
  } else {
    const storedCountry = localStorage.getItem("selectedCountry");
    if (storedCountry) {
      const parsedCountry = JSON.parse(storedCountry);
      selectedCurrency = parsedCountry?.currency
    }
  }

  return (
    <div className={getClasses(className,classes.card)} onClick={handleRedirect}>
      <div className={classes.imageContainer} > 
        <img src={image} alt={altText} className={classes.image} />
        <button className={classes.heartButton} onClick={e => e.stopPropagation()}>
        {isWishListItem ? (
          <FontAwesomeIcon className={classes.filledHeart} icon={filledHeart} onClick={(e) => handleRemove(e)}/>
        ) : (
          <FontAwesomeIcon icon={faHeart} className={classes.buttonText} onClick={handleAddWishlist}/>
        )}
          
          </button>
      </div>
      <div className={classes.content}>
        <div className={classes.topRow}>
          <div className={classes.titleContainer}>
            <h3 className={classes.title} title={title}>{title}</h3>
            <p className={classes.author} title={author}>{author}</p>
          </div>
        </div>
        <div className={classes.bottomRow}>
        {price?.discounted ? (
              <div>
                <p className={classes.priceStriked}>{`${selectedCurrency} ${price?.original}`}</p>
                <p className={classes.price}>{`${selectedCurrency} ${price?.discounted}`}</p>
              </div>
            ) : (
              <p className={classes.price}>{`${selectedCurrency} ${price?.original}`}</p>
            )}
        </div>
        <div className={classes.addToCartButton}>
            <button>Preview</button>
        </div>
      </div>
    </div>
  );
};

export default Card;
